import React, { useEffect, useState } from 'react'
import { convertDateToString, discountedPrice, getBookingDate } from '../controller/control'
import Button from '@mui/material/Button';
import { createStore } from "../store/state"
import { useNavigate } from "react-router-dom"
import { IoIosCloseCircle } from "react-icons/io";
import { toast, Toaster } from "sonner"
import { useDispatch, useSelector } from "react-redux"
import { addToCart, getCartNumber, getCartList } from '../features/cartSlice';
import { nanoid } from '@reduxjs/toolkit';
import { PiMoney } from "react-icons/pi";
import { FaGraduationCap } from "react-icons/fa";
import { LiaLanguageSolid } from "react-icons/lia";
import { FaUserDoctor } from "react-icons/fa6";
import api from '../controller/api';

export default function ProductCard({ product, bookingList }) {
    const [categoryDetails, setCategoryDetails] = useState({})
    const [pageLoading, setPageLoading] = useState(false)
    const [modelOpen, setModelOpen] = useState(false)

    const [activeDate, setActiveDate] = useState("")
    const [selectedTime, setSelectedTime] = useState('')
    const [productId, setProductId] = useState("")

    const { user } = createStore((state) => state)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const cartCount = useSelector(getCartNumber)
    const cartList = useSelector(getCartList)

    const bookingDate = getBookingDate()
    const hours = ["10am", "11am", "12pm", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm"]

    const handleModelOpen = (id) => {
        if (user) {
            setModelOpen(true)
            setProductId(id)
        }
        else {
            navigate('/login')
        }
    }

    const handleCurrentDate = (booking) => {
        setActiveDate(booking)
        setSelectedTime("")
    }

    const handleAddProduct = (product) => {
        if (!selectedTime || !activeDate) return toast.error("Select date and time")
        const isDateOnCart = cartList.find((item) => item.productId === productId && item.bookingDate === activeDate && item.time === selectedTime)

        if (isDateOnCart) {
            return toast.error("Item already on the cart")
        } else {
            dispatch(addToCart({
                ...product,
                id: nanoid(),
                productId: productId,
                bookingDate: activeDate,
                time: selectedTime,
                categoryName: categoryDetails.categoryName
            }))

            toast.success("Date added on the cart")
        }
        setActiveDate()
        setSelectedTime()
    }

    const fetchCategoryById = async () => {
        try {
            const { data: res } = await api.get(`/category/details/${product?.categoryId}`)
            setCategoryDetails(res)
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        }
    }

    const checkAll = bookingList.filter((t) => t.productId === productId && convertDateToString(t.bookingDate) === activeDate)
    const checkTime = (time) => {
        const bookedTime = checkAll.find((item) => convertDateToString(item.bookingDate) === activeDate && item.time === time && item.isBooked === true)
        return bookedTime
    }

    useEffect(() => {
        setPageLoading(true)
    }, [checkAll])

    useEffect(() => {
        fetchCategoryById()
    }, [])

    return (
        <>
            <Toaster richColors position="top-center" />
            <div className='product-details'>
                <div className="user-profile">
                    <div>
                        <img src={product.productImgUrl} alt={product.title} />
                    </div>
                    <div>
                        <h3>{product.title}</h3>
                        <p className="profile-icons">
                            <FaUserDoctor size={22} />
                            <span className='fees'>{categoryDetails.categoryName}</span>
                        </p>
                        <p className="profile-icons">
                            <PiMoney size={22} />
                            <span className='fees'>₹{product.price}</span>
                        </p>
                        <p className="profile-icons">
                            <FaGraduationCap size={22} />
                            <span>{product.experience} years of Experience</span>
                        </p>
                        <p className="profile-icons">
                            <LiaLanguageSolid size={22} />
                            <span>Speaks: {product.language.join(", ")}</span>
                        </p>
                    </div>
                </div>
                <div className='button-manage'>
                    <Button variant="contained" size='small' color='error' onClick={() => handleModelOpen(product._id)}>
                        Book Now
                    </Button>
                </div>
            </div >
            {modelOpen && <div className='modal-booking'>
                <div className='modal-details'>
                    <IoIosCloseCircle onClick={() => setModelOpen(false)} size="32" className='model-close' />
                    <h3>Select your Booking date</h3>
                    <div className='modal-header'>
                        <div>
                            <img src={product.productImgUrl} alt={product.title} />
                        </div>
                        <div>
                            <h4>{product.title}</h4>
                            <p className="profile-icons">
                                <FaUserDoctor size={22} />
                                <span>{categoryDetails.categoryName}</span>
                            </p>
                        </div>
                        <div>
                            {/* <span className='line-through'>Rs. {product.price}</span> Rs. {discountedPrice(product.price, product.discount)} */}
                            <span>Fees: ₹ {product.price}</span>
                        </div>
                    </div>
                    <div className='date-picker'>
                        {bookingDate.map((booking, i) =>
                            <div className={`date-pick ${activeDate === booking ? "picked" : ""} ${booking === "Thu May 15 2025" && product._id === "68067b27f794d4ab4a2aa3e5" && "booked-date"}`}
                                key={i} onClick={() => handleCurrentDate(booking)}>
                                {/* <span>{booking}</span> */}
                                <span>{booking.slice(0, -12)}</span>
                                <br />{booking.slice(8, -5)}
                            </div>)}
                    </div>
                    <div className='time-list'>
                        {checkAll.length > 0 ?
                            <>
                                {hours.map((hour) => <span key={hour} onClick={() => setSelectedTime(hour)} className={`book-hour ${checkTime(hour) ? "booked-time" : ""} ${selectedTime === hour ? "time-selected" : ""}`}>{hour}</span>)}
                            </>
                            : <>
                                {hours.map((hour) => <span key={hour} onClick={() => setSelectedTime(hour)} className={`book-hour ${selectedTime === hour ? "time-selected" : ""} `}>{hour}</span>)}
                            </>
                        }
                    </div>
                    <Button variant="contained" type='submit' size='small' color='error' onClick={() => handleAddProduct(product)}>
                        Make an appointment
                    </Button>
                </div>
            </div>
            }
        </>
    )
}
